export default {
    title: 'Cloud Hosting',
    cloud_hosting: 'Cloud Hosting',
    cloud_hosting_extend: 'Extend Cloud Hosting',
    cloud_hosting_upgrade: 'Upgrade Cloud Hosting',
    credentials: 'Credentials',
    service_package: 'Service Package',
    invoice_id: 'Invoice ID',
    machine_name: 'Machine Name',
    reg_date: 'Reg Date',
    due_date: 'Exp Date',
    server_status: 'Server Status',
    server_package_status: 'Package Status',
    server_name: 'Server name',
    project_name: 'Project name',
    package_status: 'Package status',
    specifications: 'Specifications',
    ip: 'Public IP',
    additional_ip: 'Additional IP',
    additional_file_storage: 'Additional File Storage',
    additional_database_storage: 'Additional Database Storage',
    username: 'Cloud Panel Username',
    terminal_username: 'Terminal Username',
    password: 'Password',
    cloud_hosting_detail: 'Cloud Hosting Detail',
    dashboard: 'Dashboard',
    cloud_hosting_info: 'Cloud Hosting Information',
    order_code: 'Order code',
    cloud_hosting_package: 'Cloud Hosting Package',
    application: 'Application',
    payment_plan: 'Payment Plan',
    action: 'Action',
    cloud_panel: 'Cloud Panel',
    reset_warning:
        'This will reset and re-install the instance, you will lose all existing data on this server, would you like to proceed?',
    package_addons: {
        storage: 'Storage',
    },
    cloud_hosting_reset_failed: 'Reset failed. Please try again.',
    auto_renew: 'Auto Renew',
    upgrade_warning:
        'You need to pay this order within the day, otherwise the order will be deleted',
    package_name: 'Package Name',
    change_terminal_password: 'Change Terminal Password',
    change_panel_password: 'Change Panel Password',
};
